import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { BrandProvider } from "@/context/BrandProvider";
import { AuthProvider } from "@/context/AuthProvider";
import GlobalProgress from "@/components/feature/GlobalProgress";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <GlobalProgress />
      <AuthProvider>
        <BrandProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </BrandProvider>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;
